class ProductSlider extends HTMLElement {
  constructor () {
    super()
    this.carousel = this.querySelector('site-carousel')
  }

  connectedCallback () {
    // if (!this.carousel) return;
  }

  previous () {
    if (this.swiper) {
      this.swiper.slidePrev()
    }
  }

  next () {
    if (this.swiper) {
      this.swiper.slideNext()
    }
  }

  slideTo (index) {
    if (this.swiper) {
      this.swiper.slideTo(index)
    }
  }
}

customElements.define('product-slider', ProductSlider)
